<template>
  <div class="mt-4 grid gap-4 md:grid-cols-3">
    <LabeledText :label="t('driver')"
      >{{ transfer.transferOf?.booking?.customerData?.firstName ?? 'n/a' }}
      {{ transfer.transferOf?.booking?.customerData?.lastName ?? 'n/a' }}</LabeledText
    >

    <LabeledText :label="t('bookingNumber')">
      <span v-if="transfer.transferOf?.booking" class="inline-flex items-center gap-1">
        <RouterLink
          :to="{ name: 'bookingPlanEdit', params: { id: transfer.transferOf.booking.id } }"
        >
          {{ transfer.transferOf.booking.bookingNumber }}
        </RouterLink>
        <CopyToClipboardButton :text="transfer.transferOf.booking.bookingNumber" />
      </span>
      <template v-else>n/a</template>
    </LabeledText>

    <LabeledText :label="t('internalComment')">
      {{ transfer.comment ?? '-' }}
    </LabeledText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { RouterLink } from 'vue-router';
import CopyToClipboardButton from '@/components/CopyToClipboardButton.vue';
import LabeledText from '@/components/LabeledText.vue';
import type { Allocation } from '@/entities/allocations/allocation.entity.ts';

const { t } = useI18n();
defineProps<{
  transfer: Allocation;
}>();
</script>

<i18n lang="json">
{
  "en": {
    "internalComment": "Transfer Comment",
    "returnOverview": "Return overview",
    "driver": "Driver",
    "bookingNumber": "Booking Nr."
  },
  "de": {
    "internalComment": "Transfer Kommentar",
    "returnOverview": "Buchungsübersicht",
    "driver": "Fahrer",
    "bookingNumber": "Buchungs Nr."
  },
  "es": {
    "internalComment": "Comentario del traslado",
    "returnOverview": "Vista general de la devolución",
    "driver": "Conductor",
    "bookingNumber": "N.º reserva"
  }
}
</i18n>
